export default {
  default: () => import("/home/tickets-hzbmt/tickets.muzieum.nl/client/layouts/default.vue").then(m => m.default || m)
}